import { useEffect, useState } from "react";

import { QuizStepProps } from "../useQuestionnaire";

import { Option } from "./components/Option";

export const WeightLossGoal = (props: QuizStepProps) => {
  const hasError = !!props.errors?.Goal;
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("Goal", value);
    setLastUpdate({ key: "Goal", value });
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  const options = [
    { name: "1-20 lbs", value: "20" },
    { name: "21-50 lbs", value: "21" },
    { name: "50+ lbs", value: "50" },
    { name: "Maintain my weight and get fit.", value: "Maintain" },
    { name: "Haven't Decided", value: "Undecided" },
  ];

  return (
    <div>
      <div
        className={`mr-8 mt-1 pb-6 font-serif text-h3 peer-aria-invalid:text-red ${
          hasError ? "text-red" : ""
        }`}
      >
        What is your weight loss goal?
      </div>
      <div>
        <div className="flex flex-wrap gap-3" key="Goal">
          {options.map((option) => (
            <Option
              key={option.value}
              name={option.name}
              value={option.value}
              checked={props.data.Goal === option.value}
              onChange={(e) => handleChange(option.value)}
            />
          ))}
        </div>
        {hasError && <div className="mt-2 text-red">* Required</div>}
      </div>
    </div>
  );
};

export default WeightLossGoal;
